import { PaymentProcess } from './PaymentProcess';

export class TreasuryDocItem {
  conto: string;
  id: number;
  paymentProcesses: PaymentProcess[];

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      this.paymentProcesses = data.paymentProcesses ? data.paymentProcesses.map(pp => new PaymentProcess(pp)) : null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/TreasuryDocItem.ts